//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v10.9.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import { environment } from "@environments/environment";
import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');

export class Foo {
  protected getBaseUrl(deaultUrl: string): string {
    return environment.remoteServiceBaseUrl;
  }
}

@Injectable({
    providedIn: 'root'
})
export class CalendarServiceProxy extends Foo {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : this.getBaseUrl("");
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    saveCalendar(body: SaveCalendarInput | undefined): Observable<OwnerCalendarDto> {
        let url_ = this.baseUrl + "/api/services/app/Calendar/SaveCalendar";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveCalendar(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveCalendar(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OwnerCalendarDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OwnerCalendarDto>;
        }));
    }

    protected processSaveCalendar(response: HttpResponseBase): Observable<OwnerCalendarDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OwnerCalendarDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param start (optional) 
     * @param end (optional) 
     * @return OK
     */
    getEvents(start: Date | undefined, end: Date | undefined): Observable<CalendarEventDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Calendar/GetEvents?";
        if (start === null)
            throw new Error("The parameter 'start' cannot be null.");
        else if (start !== undefined)
            url_ += "Start=" + encodeURIComponent(start ? "" + start.toISOString() : "") + "&";
        if (end === null)
            throw new Error("The parameter 'end' cannot be null.");
        else if (end !== undefined)
            url_ += "End=" + encodeURIComponent(end ? "" + end.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEvents(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEvents(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CalendarEventDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CalendarEventDto[]>;
        }));
    }

    protected processGetEvents(response: HttpResponseBase): Observable<CalendarEventDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CalendarEventDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getAllEvents(): Observable<CalendarEventDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Calendar/GetAllEvents";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllEvents(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllEvents(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CalendarEventDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CalendarEventDto[]>;
        }));
    }

    protected processGetAllEvents(response: HttpResponseBase): Observable<CalendarEventDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CalendarEventDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    getCalendarEvent(id: string | undefined): Observable<CalendarEventDto> {
        let url_ = this.baseUrl + "/api/services/app/Calendar/GetCalendarEvent?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCalendarEvent(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCalendarEvent(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CalendarEventDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CalendarEventDto>;
        }));
    }

    protected processGetCalendarEvent(response: HttpResponseBase): Observable<CalendarEventDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CalendarEventDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getCalendars(): Observable<OwnerCalendarDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Calendar/GetCalendars";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCalendars(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCalendars(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OwnerCalendarDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OwnerCalendarDto[]>;
        }));
    }

    protected processGetCalendars(response: HttpResponseBase): Observable<OwnerCalendarDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OwnerCalendarDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    removeCalendar(id: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Calendar/RemoveCalendar?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemoveCalendar(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemoveCalendar(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRemoveCalendar(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param url (optional) 
     * @return OK
     */
    getIsCalendarUrlFree(url: string | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Calendar/GetIsCalendarUrlFree?";
        if (url === null)
            throw new Error("The parameter 'url' cannot be null.");
        else if (url !== undefined)
            url_ += "url=" + encodeURIComponent("" + url) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetIsCalendarUrlFree(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetIsCalendarUrlFree(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processGetIsCalendarUrlFree(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    cancelAttendance(body: CancelAttendanceInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Calendar/CancelAttendance";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCancelAttendance(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCancelAttendance(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCancelAttendance(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    cancelEventForOwner(body: CancelEventAsyncInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Calendar/CancelEventForOwner";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCancelEventForOwner(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCancelEventForOwner(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCancelEventForOwner(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    getCalendarUrlFromAttendenceId(id: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Calendar/GetCalendarUrlFromAttendenceId?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCalendarUrlFromAttendenceId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCalendarUrlFromAttendenceId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetCalendarUrlFromAttendenceId(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param name (optional) 
     * @return OK
     */
    getUrlFromName(name: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Calendar/GetUrlFromName?";
        if (name === null)
            throw new Error("The parameter 'name' cannot be null.");
        else if (name !== undefined)
            url_ += "name=" + encodeURIComponent("" + name) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUrlFromName(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUrlFromName(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetUrlFromName(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    getAttendeesForEvent(id: string | undefined): Observable<AttendanceDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Calendar/GetAttendeesForEvent?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAttendeesForEvent(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAttendeesForEvent(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AttendanceDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AttendanceDto[]>;
        }));
    }

    protected processGetAttendeesForEvent(response: HttpResponseBase): Observable<AttendanceDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AttendanceDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    getCalendar(id: string | undefined): Observable<OwnerCalendarDto> {
        let url_ = this.baseUrl + "/api/services/app/Calendar/GetCalendar?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCalendar(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCalendar(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OwnerCalendarDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OwnerCalendarDto>;
        }));
    }

    protected processGetCalendar(response: HttpResponseBase): Observable<OwnerCalendarDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OwnerCalendarDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    getCalendarByUrl(id: string | undefined): Observable<OwnerCalendarDto> {
        let url_ = this.baseUrl + "/api/services/app/Calendar/GetCalendarByUrl?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCalendarByUrl(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCalendarByUrl(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OwnerCalendarDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OwnerCalendarDto>;
        }));
    }

    protected processGetCalendarByUrl(response: HttpResponseBase): Observable<OwnerCalendarDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OwnerCalendarDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getUpcommingMeetingsCount(): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Calendar/GetUpcommingMeetingsCount";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUpcommingMeetingsCount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUpcommingMeetingsCount(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGetUpcommingMeetingsCount(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    refreshEventTypes(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Calendar/RefreshEventTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRefreshEventTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRefreshEventTypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRefreshEventTypes(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    createDefaultCalendar(): Observable<OwnerCalendarDto> {
        let url_ = this.baseUrl + "/api/services/app/Calendar/CreateDefaultCalendar";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateDefaultCalendar(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateDefaultCalendar(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OwnerCalendarDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OwnerCalendarDto>;
        }));
    }

    protected processCreateDefaultCalendar(response: HttpResponseBase): Observable<OwnerCalendarDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OwnerCalendarDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    retrieveSlotsForEditorPreview(body: GetSlotsForEditorPreviewInput | undefined): Observable<GetSlotsOutput> {
        let url_ = this.baseUrl + "/api/services/app/Calendar/RetrieveSlotsForEditorPreview";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRetrieveSlotsForEditorPreview(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRetrieveSlotsForEditorPreview(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetSlotsOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetSlotsOutput>;
        }));
    }

    protected processRetrieveSlotsForEditorPreview(response: HttpResponseBase): Observable<GetSlotsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetSlotsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getPossibleHosts(): Observable<PossibleEventTypeHostDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Calendar/GetPossibleHosts";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPossibleHosts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPossibleHosts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PossibleEventTypeHostDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PossibleEventTypeHostDto[]>;
        }));
    }

    protected processGetPossibleHosts(response: HttpResponseBase): Observable<PossibleEventTypeHostDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PossibleEventTypeHostDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getSessionUserLanguage(): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Calendar/GetSessionUserLanguage";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSessionUserLanguage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSessionUserLanguage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetSessionUserLanguage(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export class AttendanceDto implements IAttendanceDto {
    id!: string;
    calendarEventId!: string;
    attendeeName!: string | undefined;
    attendeeEmail!: string | undefined;
    reason!: string | undefined;
    deleter!: string | undefined;
    guestQuestionAnswers!: GuestQuestionAnswers[] | undefined;
    eventTypeId!: string;
    creationTime!: Date;
    timeZone!: string | undefined;
    rescheduledFrom!: AttendanceDto;
    isDeleted!: boolean;
    paymentAmount!: number;
    paymentCurrency!: string | undefined;
    paymentAccountId!: string | undefined;
    paymentReference!: string | undefined;

    constructor(data?: IAttendanceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.guestQuestionAnswers) {
                this.guestQuestionAnswers = [];
                for (let i = 0; i < data.guestQuestionAnswers.length; i++) {
                    let item = data.guestQuestionAnswers[i];
                    this.guestQuestionAnswers[i] = item && !(<any>item).toJSON ? new GuestQuestionAnswers(item) : <GuestQuestionAnswers>item;
                }
            }
            this.rescheduledFrom = data.rescheduledFrom && !(<any>data.rescheduledFrom).toJSON ? new AttendanceDto(data.rescheduledFrom) : <AttendanceDto>this.rescheduledFrom;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.calendarEventId = _data["calendarEventId"];
            this.attendeeName = _data["attendeeName"];
            this.attendeeEmail = _data["attendeeEmail"];
            this.reason = _data["reason"];
            this.deleter = _data["deleter"];
            if (Array.isArray(_data["guestQuestionAnswers"])) {
                this.guestQuestionAnswers = [] as any;
                for (let item of _data["guestQuestionAnswers"])
                    this.guestQuestionAnswers!.push(GuestQuestionAnswers.fromJS(item));
            }
            this.eventTypeId = _data["eventTypeId"];
            this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
            this.timeZone = _data["timeZone"];
            this.rescheduledFrom = _data["rescheduledFrom"] ? AttendanceDto.fromJS(_data["rescheduledFrom"]) : <any>undefined;
            this.isDeleted = _data["isDeleted"];
            this.paymentAmount = _data["paymentAmount"];
            this.paymentCurrency = _data["paymentCurrency"];
            this.paymentAccountId = _data["paymentAccountId"];
            this.paymentReference = _data["paymentReference"];
        }
    }

    static fromJS(data: any): AttendanceDto {
        data = typeof data === 'object' ? data : {};
        let result = new AttendanceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["calendarEventId"] = this.calendarEventId;
        data["attendeeName"] = this.attendeeName;
        data["attendeeEmail"] = this.attendeeEmail;
        data["reason"] = this.reason;
        data["deleter"] = this.deleter;
        if (Array.isArray(this.guestQuestionAnswers)) {
            data["guestQuestionAnswers"] = [];
            for (let item of this.guestQuestionAnswers)
                data["guestQuestionAnswers"].push(item.toJSON());
        }
        data["eventTypeId"] = this.eventTypeId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["timeZone"] = this.timeZone;
        data["rescheduledFrom"] = this.rescheduledFrom ? this.rescheduledFrom.toJSON() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["paymentAmount"] = this.paymentAmount;
        data["paymentCurrency"] = this.paymentCurrency;
        data["paymentAccountId"] = this.paymentAccountId;
        data["paymentReference"] = this.paymentReference;
        return data;
    }
}

export interface IAttendanceDto {
    id: string;
    calendarEventId: string;
    attendeeName: string | undefined;
    attendeeEmail: string | undefined;
    reason: string | undefined;
    deleter: string | undefined;
    guestQuestionAnswers: IGuestQuestionAnswers[] | undefined;
    eventTypeId: string;
    creationTime: Date;
    timeZone: string | undefined;
    rescheduledFrom: IAttendanceDto;
    isDeleted: boolean;
    paymentAmount: number;
    paymentCurrency: string | undefined;
    paymentAccountId: string | undefined;
    paymentReference: string | undefined;
}

export class CalendarAvailability implements ICalendarAvailability {
    individual!: { [key: string]: TimeRange[]; } | undefined;
    weeklyRepeating!: { [key: string]: TimeRange[]; } | undefined;

    constructor(data?: ICalendarAvailability) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (_data["individual"]) {
                this.individual = {} as any;
                for (let key in _data["individual"]) {
                    if (_data["individual"].hasOwnProperty(key))
                        (<any>this.individual)![key] = _data["individual"][key] ? _data["individual"][key].map((i: any) => TimeRange.fromJS(i)) : <any>undefined;
                }
            }
            if (_data["weeklyRepeating"]) {
                this.weeklyRepeating = {} as any;
                for (let key in _data["weeklyRepeating"]) {
                    if (_data["weeklyRepeating"].hasOwnProperty(key))
                        (<any>this.weeklyRepeating)![key] = _data["weeklyRepeating"][key] ? _data["weeklyRepeating"][key].map((i: any) => TimeRange.fromJS(i)) : <any>undefined;
                }
            }
        }
    }

    static fromJS(data: any): CalendarAvailability {
        data = typeof data === 'object' ? data : {};
        let result = new CalendarAvailability();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.individual) {
            data["individual"] = {};
            for (let key in this.individual) {
                if (this.individual.hasOwnProperty(key))
                    (<any>data["individual"])[key] = (<any>this.individual)[key];
            }
        }
        if (this.weeklyRepeating) {
            data["weeklyRepeating"] = {};
            for (let key in this.weeklyRepeating) {
                if (this.weeklyRepeating.hasOwnProperty(key))
                    (<any>data["weeklyRepeating"])[key] = (<any>this.weeklyRepeating)[key];
            }
        }
        return data;
    }
}

export interface ICalendarAvailability {
    individual: { [key: string]: TimeRange[]; } | undefined;
    weeklyRepeating: { [key: string]: TimeRange[]; } | undefined;
}

export class CalendarEventDto implements ICalendarEventDto {
    id!: string;
    start!: Date;
    duration!: number;
    end!: Date;
    eventName!: string | undefined;
    attendees!: AttendanceDto[] | undefined;
    url!: string | undefined;
    isDeleted!: boolean;
    eventTypeId!: string;
    location!: string | undefined;
    ownerCalendarIsDeleted!: boolean;
    ownerFullName!: string | undefined;
    ownerCalendarName!: string | undefined;
    ownerCalendarUrl!: string | undefined;
    ownerCalendarCalendarOptions!: CalendarOptionsDto;
    ownerCalendarIsActive!: boolean;
    ownerCalendarOwnerId!: number;
    ownerCalendarOwnerFullName!: string | undefined;
    zoomMeetingUrl!: string | undefined;
    zoomMeetingPassword!: string | undefined;
    googleMeetingUrl!: string | undefined;
    googleMeetingPassword!: string | undefined;
    microsoftMeetingUrl!: string | undefined;
    microsoftMeetingPassword!: string | undefined;
    host!: HostUserDto;
    additionalHosts!: HostUserDto[] | undefined;

    constructor(data?: ICalendarEventDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.attendees) {
                this.attendees = [];
                for (let i = 0; i < data.attendees.length; i++) {
                    let item = data.attendees[i];
                    this.attendees[i] = item && !(<any>item).toJSON ? new AttendanceDto(item) : <AttendanceDto>item;
                }
            }
            this.ownerCalendarCalendarOptions = data.ownerCalendarCalendarOptions && !(<any>data.ownerCalendarCalendarOptions).toJSON ? new CalendarOptionsDto(data.ownerCalendarCalendarOptions) : <CalendarOptionsDto>this.ownerCalendarCalendarOptions;
            this.host = data.host && !(<any>data.host).toJSON ? new HostUserDto(data.host) : <HostUserDto>this.host;
            if (data.additionalHosts) {
                this.additionalHosts = [];
                for (let i = 0; i < data.additionalHosts.length; i++) {
                    let item = data.additionalHosts[i];
                    this.additionalHosts[i] = item && !(<any>item).toJSON ? new HostUserDto(item) : <HostUserDto>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.start = _data["start"] ? new Date(_data["start"].toString()) : <any>undefined;
            this.duration = _data["duration"];
            this.end = _data["end"] ? new Date(_data["end"].toString()) : <any>undefined;
            this.eventName = _data["eventName"];
            if (Array.isArray(_data["attendees"])) {
                this.attendees = [] as any;
                for (let item of _data["attendees"])
                    this.attendees!.push(AttendanceDto.fromJS(item));
            }
            this.url = _data["url"];
            this.isDeleted = _data["isDeleted"];
            this.eventTypeId = _data["eventTypeId"];
            this.location = _data["location"];
            this.ownerCalendarIsDeleted = _data["ownerCalendarIsDeleted"];
            this.ownerFullName = _data["ownerFullName"];
            this.ownerCalendarName = _data["ownerCalendarName"];
            this.ownerCalendarUrl = _data["ownerCalendarUrl"];
            this.ownerCalendarCalendarOptions = _data["ownerCalendarCalendarOptions"] ? CalendarOptionsDto.fromJS(_data["ownerCalendarCalendarOptions"]) : <any>undefined;
            this.ownerCalendarIsActive = _data["ownerCalendarIsActive"];
            this.ownerCalendarOwnerId = _data["ownerCalendarOwnerId"];
            this.ownerCalendarOwnerFullName = _data["ownerCalendarOwnerFullName"];
            this.zoomMeetingUrl = _data["zoomMeetingUrl"];
            this.zoomMeetingPassword = _data["zoomMeetingPassword"];
            this.googleMeetingUrl = _data["googleMeetingUrl"];
            this.googleMeetingPassword = _data["googleMeetingPassword"];
            this.microsoftMeetingUrl = _data["microsoftMeetingUrl"];
            this.microsoftMeetingPassword = _data["microsoftMeetingPassword"];
            this.host = _data["host"] ? HostUserDto.fromJS(_data["host"]) : <any>undefined;
            if (Array.isArray(_data["additionalHosts"])) {
                this.additionalHosts = [] as any;
                for (let item of _data["additionalHosts"])
                    this.additionalHosts!.push(HostUserDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CalendarEventDto {
        data = typeof data === 'object' ? data : {};
        let result = new CalendarEventDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["start"] = this.start ? this.start.toISOString() : <any>undefined;
        data["duration"] = this.duration;
        data["end"] = this.end ? this.end.toISOString() : <any>undefined;
        data["eventName"] = this.eventName;
        if (Array.isArray(this.attendees)) {
            data["attendees"] = [];
            for (let item of this.attendees)
                data["attendees"].push(item.toJSON());
        }
        data["url"] = this.url;
        data["isDeleted"] = this.isDeleted;
        data["eventTypeId"] = this.eventTypeId;
        data["location"] = this.location;
        data["ownerCalendarIsDeleted"] = this.ownerCalendarIsDeleted;
        data["ownerFullName"] = this.ownerFullName;
        data["ownerCalendarName"] = this.ownerCalendarName;
        data["ownerCalendarUrl"] = this.ownerCalendarUrl;
        data["ownerCalendarCalendarOptions"] = this.ownerCalendarCalendarOptions ? this.ownerCalendarCalendarOptions.toJSON() : <any>undefined;
        data["ownerCalendarIsActive"] = this.ownerCalendarIsActive;
        data["ownerCalendarOwnerId"] = this.ownerCalendarOwnerId;
        data["ownerCalendarOwnerFullName"] = this.ownerCalendarOwnerFullName;
        data["zoomMeetingUrl"] = this.zoomMeetingUrl;
        data["zoomMeetingPassword"] = this.zoomMeetingPassword;
        data["googleMeetingUrl"] = this.googleMeetingUrl;
        data["googleMeetingPassword"] = this.googleMeetingPassword;
        data["microsoftMeetingUrl"] = this.microsoftMeetingUrl;
        data["microsoftMeetingPassword"] = this.microsoftMeetingPassword;
        data["host"] = this.host ? this.host.toJSON() : <any>undefined;
        if (Array.isArray(this.additionalHosts)) {
            data["additionalHosts"] = [];
            for (let item of this.additionalHosts)
                data["additionalHosts"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICalendarEventDto {
    id: string;
    start: Date;
    duration: number;
    end: Date;
    eventName: string | undefined;
    attendees: IAttendanceDto[] | undefined;
    url: string | undefined;
    isDeleted: boolean;
    eventTypeId: string;
    location: string | undefined;
    ownerCalendarIsDeleted: boolean;
    ownerFullName: string | undefined;
    ownerCalendarName: string | undefined;
    ownerCalendarUrl: string | undefined;
    ownerCalendarCalendarOptions: ICalendarOptionsDto;
    ownerCalendarIsActive: boolean;
    ownerCalendarOwnerId: number;
    ownerCalendarOwnerFullName: string | undefined;
    zoomMeetingUrl: string | undefined;
    zoomMeetingPassword: string | undefined;
    googleMeetingUrl: string | undefined;
    googleMeetingPassword: string | undefined;
    microsoftMeetingUrl: string | undefined;
    microsoftMeetingPassword: string | undefined;
    host: IHostUserDto;
    additionalHosts: IHostUserDto[] | undefined;
}

export class CalendarOptions implements ICalendarOptions {
    profilePic!: string | undefined;
    meetingLengths!: number[] | undefined;
    availabilityIncrements!: number;
    minimumNoticeMinutes!: number;
    calendarAvailability!: CalendarAvailability;
    description!: string | undefined;
    headline!: string | undefined;
    subline!: string | undefined;
    color!: string | undefined;
    dateRangeType!: string | undefined;
    dateRangeRollingPeriod!: number | undefined;
    dateRangeDateRange!: DateTimeRange;
    location!: string | undefined;
    showLocationBeforeConfirmation!: boolean;
    locationSetting!: LocationSettingEnum;
    guestChoosesLocation!: boolean;
    guestLocationFreeChoice!: boolean;
    guestLocationChoices!: string[] | undefined;
    guestChoosesLocationQuestionText!: string | undefined;
    guestLocationChoicesAllowOther!: boolean;
    guestQuestions!: GuestQuestion[] | undefined;
    reminderEmailSettings!: number[] | undefined;
    maxAttendees!: number;

    constructor(data?: ICalendarOptions) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.calendarAvailability = data.calendarAvailability && !(<any>data.calendarAvailability).toJSON ? new CalendarAvailability(data.calendarAvailability) : <CalendarAvailability>this.calendarAvailability;
            this.dateRangeDateRange = data.dateRangeDateRange && !(<any>data.dateRangeDateRange).toJSON ? new DateTimeRange(data.dateRangeDateRange) : <DateTimeRange>this.dateRangeDateRange;
            if (data.guestQuestions) {
                this.guestQuestions = [];
                for (let i = 0; i < data.guestQuestions.length; i++) {
                    let item = data.guestQuestions[i];
                    this.guestQuestions[i] = item && !(<any>item).toJSON ? new GuestQuestion(item) : <GuestQuestion>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.profilePic = _data["profilePic"];
            if (Array.isArray(_data["meetingLengths"])) {
                this.meetingLengths = [] as any;
                for (let item of _data["meetingLengths"])
                    this.meetingLengths!.push(item);
            }
            this.availabilityIncrements = _data["availabilityIncrements"];
            this.minimumNoticeMinutes = _data["minimumNoticeMinutes"];
            this.calendarAvailability = _data["calendarAvailability"] ? CalendarAvailability.fromJS(_data["calendarAvailability"]) : <any>undefined;
            this.description = _data["description"];
            this.headline = _data["headline"];
            this.subline = _data["subline"];
            this.color = _data["color"];
            this.dateRangeType = _data["dateRangeType"];
            this.dateRangeRollingPeriod = _data["dateRangeRollingPeriod"];
            this.dateRangeDateRange = _data["dateRangeDateRange"] ? DateTimeRange.fromJS(_data["dateRangeDateRange"]) : <any>undefined;
            this.location = _data["location"];
            this.showLocationBeforeConfirmation = _data["showLocationBeforeConfirmation"];
            this.locationSetting = _data["locationSetting"];
            this.guestChoosesLocation = _data["guestChoosesLocation"];
            this.guestLocationFreeChoice = _data["guestLocationFreeChoice"];
            if (Array.isArray(_data["guestLocationChoices"])) {
                this.guestLocationChoices = [] as any;
                for (let item of _data["guestLocationChoices"])
                    this.guestLocationChoices!.push(item);
            }
            this.guestChoosesLocationQuestionText = _data["guestChoosesLocationQuestionText"];
            this.guestLocationChoicesAllowOther = _data["guestLocationChoicesAllowOther"];
            if (Array.isArray(_data["guestQuestions"])) {
                this.guestQuestions = [] as any;
                for (let item of _data["guestQuestions"])
                    this.guestQuestions!.push(GuestQuestion.fromJS(item));
            }
            if (Array.isArray(_data["reminderEmailSettings"])) {
                this.reminderEmailSettings = [] as any;
                for (let item of _data["reminderEmailSettings"])
                    this.reminderEmailSettings!.push(item);
            }
            this.maxAttendees = _data["maxAttendees"];
        }
    }

    static fromJS(data: any): CalendarOptions {
        data = typeof data === 'object' ? data : {};
        let result = new CalendarOptions();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["profilePic"] = this.profilePic;
        if (Array.isArray(this.meetingLengths)) {
            data["meetingLengths"] = [];
            for (let item of this.meetingLengths)
                data["meetingLengths"].push(item);
        }
        data["availabilityIncrements"] = this.availabilityIncrements;
        data["minimumNoticeMinutes"] = this.minimumNoticeMinutes;
        data["calendarAvailability"] = this.calendarAvailability ? this.calendarAvailability.toJSON() : <any>undefined;
        data["description"] = this.description;
        data["headline"] = this.headline;
        data["subline"] = this.subline;
        data["color"] = this.color;
        data["dateRangeType"] = this.dateRangeType;
        data["dateRangeRollingPeriod"] = this.dateRangeRollingPeriod;
        data["dateRangeDateRange"] = this.dateRangeDateRange ? this.dateRangeDateRange.toJSON() : <any>undefined;
        data["location"] = this.location;
        data["showLocationBeforeConfirmation"] = this.showLocationBeforeConfirmation;
        data["locationSetting"] = this.locationSetting;
        data["guestChoosesLocation"] = this.guestChoosesLocation;
        data["guestLocationFreeChoice"] = this.guestLocationFreeChoice;
        if (Array.isArray(this.guestLocationChoices)) {
            data["guestLocationChoices"] = [];
            for (let item of this.guestLocationChoices)
                data["guestLocationChoices"].push(item);
        }
        data["guestChoosesLocationQuestionText"] = this.guestChoosesLocationQuestionText;
        data["guestLocationChoicesAllowOther"] = this.guestLocationChoicesAllowOther;
        if (Array.isArray(this.guestQuestions)) {
            data["guestQuestions"] = [];
            for (let item of this.guestQuestions)
                data["guestQuestions"].push(item.toJSON());
        }
        if (Array.isArray(this.reminderEmailSettings)) {
            data["reminderEmailSettings"] = [];
            for (let item of this.reminderEmailSettings)
                data["reminderEmailSettings"].push(item);
        }
        data["maxAttendees"] = this.maxAttendees;
        return data;
    }
}

export interface ICalendarOptions {
    profilePic: string | undefined;
    meetingLengths: number[] | undefined;
    availabilityIncrements: number;
    minimumNoticeMinutes: number;
    calendarAvailability: ICalendarAvailability;
    description: string | undefined;
    headline: string | undefined;
    subline: string | undefined;
    color: string | undefined;
    dateRangeType: string | undefined;
    dateRangeRollingPeriod: number | undefined;
    dateRangeDateRange: IDateTimeRange;
    location: string | undefined;
    showLocationBeforeConfirmation: boolean;
    locationSetting: LocationSettingEnum;
    guestChoosesLocation: boolean;
    guestLocationFreeChoice: boolean;
    guestLocationChoices: string[] | undefined;
    guestChoosesLocationQuestionText: string | undefined;
    guestLocationChoicesAllowOther: boolean;
    guestQuestions: IGuestQuestion[] | undefined;
    reminderEmailSettings: number[] | undefined;
    maxAttendees: number;
}

export class CalendarOptionsDto implements ICalendarOptionsDto {
    availabilityIncrements!: number;
    minimumNoticeMinutes!: number;
    calendarAvailability!: CalendarAvailability;
    description!: string | undefined;
    headline!: string | undefined;
    subline!: string | undefined;
    color!: string | undefined;
    dateRangeType!: string | undefined;
    dateRangeRollingPeriod!: number | undefined;
    dateRangeDateRange!: DateTimeRange;
    location!: string | undefined;
    showLocationBeforeConfirmation!: boolean;
    locationSetting!: LocationSettingEnum;
    guestLocationFreeChoice!: boolean;
    guestLocationChoices!: string[] | undefined;
    guestChoosesLocationQuestionText!: string | undefined;
    guestLocationChoicesAllowOther!: boolean;
    guestQuestions!: GuestQuestion[] | undefined;
    reminderEmailSettings!: number[] | undefined;
    maxAttendees!: number;

    constructor(data?: ICalendarOptionsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.calendarAvailability = data.calendarAvailability && !(<any>data.calendarAvailability).toJSON ? new CalendarAvailability(data.calendarAvailability) : <CalendarAvailability>this.calendarAvailability;
            this.dateRangeDateRange = data.dateRangeDateRange && !(<any>data.dateRangeDateRange).toJSON ? new DateTimeRange(data.dateRangeDateRange) : <DateTimeRange>this.dateRangeDateRange;
            if (data.guestQuestions) {
                this.guestQuestions = [];
                for (let i = 0; i < data.guestQuestions.length; i++) {
                    let item = data.guestQuestions[i];
                    this.guestQuestions[i] = item && !(<any>item).toJSON ? new GuestQuestion(item) : <GuestQuestion>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.availabilityIncrements = _data["availabilityIncrements"];
            this.minimumNoticeMinutes = _data["minimumNoticeMinutes"];
            this.calendarAvailability = _data["calendarAvailability"] ? CalendarAvailability.fromJS(_data["calendarAvailability"]) : <any>undefined;
            this.description = _data["description"];
            this.headline = _data["headline"];
            this.subline = _data["subline"];
            this.color = _data["color"];
            this.dateRangeType = _data["dateRangeType"];
            this.dateRangeRollingPeriod = _data["dateRangeRollingPeriod"];
            this.dateRangeDateRange = _data["dateRangeDateRange"] ? DateTimeRange.fromJS(_data["dateRangeDateRange"]) : <any>undefined;
            this.location = _data["location"];
            this.showLocationBeforeConfirmation = _data["showLocationBeforeConfirmation"];
            this.locationSetting = _data["locationSetting"];
            this.guestLocationFreeChoice = _data["guestLocationFreeChoice"];
            if (Array.isArray(_data["guestLocationChoices"])) {
                this.guestLocationChoices = [] as any;
                for (let item of _data["guestLocationChoices"])
                    this.guestLocationChoices!.push(item);
            }
            this.guestChoosesLocationQuestionText = _data["guestChoosesLocationQuestionText"];
            this.guestLocationChoicesAllowOther = _data["guestLocationChoicesAllowOther"];
            if (Array.isArray(_data["guestQuestions"])) {
                this.guestQuestions = [] as any;
                for (let item of _data["guestQuestions"])
                    this.guestQuestions!.push(GuestQuestion.fromJS(item));
            }
            if (Array.isArray(_data["reminderEmailSettings"])) {
                this.reminderEmailSettings = [] as any;
                for (let item of _data["reminderEmailSettings"])
                    this.reminderEmailSettings!.push(item);
            }
            this.maxAttendees = _data["maxAttendees"];
        }
    }

    static fromJS(data: any): CalendarOptionsDto {
        data = typeof data === 'object' ? data : {};
        let result = new CalendarOptionsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["availabilityIncrements"] = this.availabilityIncrements;
        data["minimumNoticeMinutes"] = this.minimumNoticeMinutes;
        data["calendarAvailability"] = this.calendarAvailability ? this.calendarAvailability.toJSON() : <any>undefined;
        data["description"] = this.description;
        data["headline"] = this.headline;
        data["subline"] = this.subline;
        data["color"] = this.color;
        data["dateRangeType"] = this.dateRangeType;
        data["dateRangeRollingPeriod"] = this.dateRangeRollingPeriod;
        data["dateRangeDateRange"] = this.dateRangeDateRange ? this.dateRangeDateRange.toJSON() : <any>undefined;
        data["location"] = this.location;
        data["showLocationBeforeConfirmation"] = this.showLocationBeforeConfirmation;
        data["locationSetting"] = this.locationSetting;
        data["guestLocationFreeChoice"] = this.guestLocationFreeChoice;
        if (Array.isArray(this.guestLocationChoices)) {
            data["guestLocationChoices"] = [];
            for (let item of this.guestLocationChoices)
                data["guestLocationChoices"].push(item);
        }
        data["guestChoosesLocationQuestionText"] = this.guestChoosesLocationQuestionText;
        data["guestLocationChoicesAllowOther"] = this.guestLocationChoicesAllowOther;
        if (Array.isArray(this.guestQuestions)) {
            data["guestQuestions"] = [];
            for (let item of this.guestQuestions)
                data["guestQuestions"].push(item.toJSON());
        }
        if (Array.isArray(this.reminderEmailSettings)) {
            data["reminderEmailSettings"] = [];
            for (let item of this.reminderEmailSettings)
                data["reminderEmailSettings"].push(item);
        }
        data["maxAttendees"] = this.maxAttendees;
        return data;
    }
}

export interface ICalendarOptionsDto {
    availabilityIncrements: number;
    minimumNoticeMinutes: number;
    calendarAvailability: ICalendarAvailability;
    description: string | undefined;
    headline: string | undefined;
    subline: string | undefined;
    color: string | undefined;
    dateRangeType: string | undefined;
    dateRangeRollingPeriod: number | undefined;
    dateRangeDateRange: IDateTimeRange;
    location: string | undefined;
    showLocationBeforeConfirmation: boolean;
    locationSetting: LocationSettingEnum;
    guestLocationFreeChoice: boolean;
    guestLocationChoices: string[] | undefined;
    guestChoosesLocationQuestionText: string | undefined;
    guestLocationChoicesAllowOther: boolean;
    guestQuestions: IGuestQuestion[] | undefined;
    reminderEmailSettings: number[] | undefined;
    maxAttendees: number;
}

export class CalendarOptionsInput implements ICalendarOptionsInput {
    maxAttendees!: number;
    headline!: string | undefined;
    profilePic!: string | undefined;
    description!: string | undefined;
    availabilityIncrements!: number;
    minimumNoticeMinutes!: number;
    color!: string;
    dateRangeType!: string | undefined;
    dateRangeRollingPeriod!: number | undefined;
    dateRangeDateRange!: DateTimeRange;
    reminderEmailSettings!: number[] | undefined;
    subline!: string | undefined;
    locationSetting!: LocationSettingEnum;
    showLocationBeforeConfirmation!: boolean;
    location!: string | undefined;
    guestChoosesLocationQuestionText!: string | undefined;
    guestLocationFreeChoice!: boolean;
    guestLocationChoices!: string[] | undefined;
    guestLocationChoicesAllowOther!: boolean;
    guestQuestions!: GuestQuestion[] | undefined;

    constructor(data?: ICalendarOptionsInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.dateRangeDateRange = data.dateRangeDateRange && !(<any>data.dateRangeDateRange).toJSON ? new DateTimeRange(data.dateRangeDateRange) : <DateTimeRange>this.dateRangeDateRange;
            if (data.guestQuestions) {
                this.guestQuestions = [];
                for (let i = 0; i < data.guestQuestions.length; i++) {
                    let item = data.guestQuestions[i];
                    this.guestQuestions[i] = item && !(<any>item).toJSON ? new GuestQuestion(item) : <GuestQuestion>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.maxAttendees = _data["maxAttendees"];
            this.headline = _data["headline"];
            this.profilePic = _data["profilePic"];
            this.description = _data["description"];
            this.availabilityIncrements = _data["availabilityIncrements"];
            this.minimumNoticeMinutes = _data["minimumNoticeMinutes"];
            this.color = _data["color"];
            this.dateRangeType = _data["dateRangeType"];
            this.dateRangeRollingPeriod = _data["dateRangeRollingPeriod"];
            this.dateRangeDateRange = _data["dateRangeDateRange"] ? DateTimeRange.fromJS(_data["dateRangeDateRange"]) : <any>undefined;
            if (Array.isArray(_data["reminderEmailSettings"])) {
                this.reminderEmailSettings = [] as any;
                for (let item of _data["reminderEmailSettings"])
                    this.reminderEmailSettings!.push(item);
            }
            this.subline = _data["subline"];
            this.locationSetting = _data["locationSetting"];
            this.showLocationBeforeConfirmation = _data["showLocationBeforeConfirmation"];
            this.location = _data["location"];
            this.guestChoosesLocationQuestionText = _data["guestChoosesLocationQuestionText"];
            this.guestLocationFreeChoice = _data["guestLocationFreeChoice"];
            if (Array.isArray(_data["guestLocationChoices"])) {
                this.guestLocationChoices = [] as any;
                for (let item of _data["guestLocationChoices"])
                    this.guestLocationChoices!.push(item);
            }
            this.guestLocationChoicesAllowOther = _data["guestLocationChoicesAllowOther"];
            if (Array.isArray(_data["guestQuestions"])) {
                this.guestQuestions = [] as any;
                for (let item of _data["guestQuestions"])
                    this.guestQuestions!.push(GuestQuestion.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CalendarOptionsInput {
        data = typeof data === 'object' ? data : {};
        let result = new CalendarOptionsInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maxAttendees"] = this.maxAttendees;
        data["headline"] = this.headline;
        data["profilePic"] = this.profilePic;
        data["description"] = this.description;
        data["availabilityIncrements"] = this.availabilityIncrements;
        data["minimumNoticeMinutes"] = this.minimumNoticeMinutes;
        data["color"] = this.color;
        data["dateRangeType"] = this.dateRangeType;
        data["dateRangeRollingPeriod"] = this.dateRangeRollingPeriod;
        data["dateRangeDateRange"] = this.dateRangeDateRange ? this.dateRangeDateRange.toJSON() : <any>undefined;
        if (Array.isArray(this.reminderEmailSettings)) {
            data["reminderEmailSettings"] = [];
            for (let item of this.reminderEmailSettings)
                data["reminderEmailSettings"].push(item);
        }
        data["subline"] = this.subline;
        data["locationSetting"] = this.locationSetting;
        data["showLocationBeforeConfirmation"] = this.showLocationBeforeConfirmation;
        data["location"] = this.location;
        data["guestChoosesLocationQuestionText"] = this.guestChoosesLocationQuestionText;
        data["guestLocationFreeChoice"] = this.guestLocationFreeChoice;
        if (Array.isArray(this.guestLocationChoices)) {
            data["guestLocationChoices"] = [];
            for (let item of this.guestLocationChoices)
                data["guestLocationChoices"].push(item);
        }
        data["guestLocationChoicesAllowOther"] = this.guestLocationChoicesAllowOther;
        if (Array.isArray(this.guestQuestions)) {
            data["guestQuestions"] = [];
            for (let item of this.guestQuestions)
                data["guestQuestions"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICalendarOptionsInput {
    maxAttendees: number;
    headline: string | undefined;
    profilePic: string | undefined;
    description: string | undefined;
    availabilityIncrements: number;
    minimumNoticeMinutes: number;
    color: string;
    dateRangeType: string | undefined;
    dateRangeRollingPeriod: number | undefined;
    dateRangeDateRange: IDateTimeRange;
    reminderEmailSettings: number[] | undefined;
    subline: string | undefined;
    locationSetting: LocationSettingEnum;
    showLocationBeforeConfirmation: boolean;
    location: string | undefined;
    guestChoosesLocationQuestionText: string | undefined;
    guestLocationFreeChoice: boolean;
    guestLocationChoices: string[] | undefined;
    guestLocationChoicesAllowOther: boolean;
    guestQuestions: IGuestQuestion[] | undefined;
}

export class CalendarSlot implements ICalendarSlot {
    startTime!: Date;
    endTime!: Date;

    constructor(data?: ICalendarSlot) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.startTime = _data["startTime"] ? new Date(_data["startTime"].toString()) : <any>undefined;
            this.endTime = _data["endTime"] ? new Date(_data["endTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): CalendarSlot {
        data = typeof data === 'object' ? data : {};
        let result = new CalendarSlot();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>undefined;
        return data;
    }
}

export interface ICalendarSlot {
    startTime: Date;
    endTime: Date;
}

export class CancelAttendanceInput implements ICancelAttendanceInput {
    id!: string;
    reason!: string | undefined;
    sendRescheduleLink!: boolean;

    constructor(data?: ICancelAttendanceInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.reason = _data["reason"];
            this.sendRescheduleLink = _data["sendRescheduleLink"];
        }
    }

    static fromJS(data: any): CancelAttendanceInput {
        data = typeof data === 'object' ? data : {};
        let result = new CancelAttendanceInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["reason"] = this.reason;
        data["sendRescheduleLink"] = this.sendRescheduleLink;
        return data;
    }
}

export interface ICancelAttendanceInput {
    id: string;
    reason: string | undefined;
    sendRescheduleLink: boolean;
}

export class CancelEventAsyncInput implements ICancelEventAsyncInput {
    id!: string;
    reason!: string | undefined;
    sendRescheduleLink!: boolean;

    constructor(data?: ICancelEventAsyncInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.reason = _data["reason"];
            this.sendRescheduleLink = _data["sendRescheduleLink"];
        }
    }

    static fromJS(data: any): CancelEventAsyncInput {
        data = typeof data === 'object' ? data : {};
        let result = new CancelEventAsyncInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["reason"] = this.reason;
        data["sendRescheduleLink"] = this.sendRescheduleLink;
        return data;
    }
}

export interface ICancelEventAsyncInput {
    id: string;
    reason: string | undefined;
    sendRescheduleLink: boolean;
}

export class DateTimeRange implements IDateTimeRange {
    startTime!: Date;
    endTime!: Date;

    constructor(data?: IDateTimeRange) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.startTime = _data["startTime"] ? new Date(_data["startTime"].toString()) : <any>undefined;
            this.endTime = _data["endTime"] ? new Date(_data["endTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): DateTimeRange {
        data = typeof data === 'object' ? data : {};
        let result = new DateTimeRange();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>undefined;
        return data;
    }
}

export interface IDateTimeRange {
    startTime: Date;
    endTime: Date;
}

export class DurationPackageDto implements IDurationPackageDto {
    id!: string;
    minutes!: number;
    paymentAmount!: number;

    constructor(data?: IDurationPackageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.minutes = _data["minutes"];
            this.paymentAmount = _data["paymentAmount"];
        }
    }

    static fromJS(data: any): DurationPackageDto {
        data = typeof data === 'object' ? data : {};
        let result = new DurationPackageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["minutes"] = this.minutes;
        data["paymentAmount"] = this.paymentAmount;
        return data;
    }
}

export interface IDurationPackageDto {
    id: string;
    minutes: number;
    paymentAmount: number;
}

export class DurationPackageInput implements IDurationPackageInput {
    minutes!: number;
    paymentAmount!: number;

    constructor(data?: IDurationPackageInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.minutes = _data["minutes"];
            this.paymentAmount = _data["paymentAmount"];
        }
    }

    static fromJS(data: any): DurationPackageInput {
        data = typeof data === 'object' ? data : {};
        let result = new DurationPackageInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["minutes"] = this.minutes;
        data["paymentAmount"] = this.paymentAmount;
        return data;
    }
}

export interface IDurationPackageInput {
    minutes: number;
    paymentAmount: number;
}

export class EventTypeHostBase implements IEventTypeHostBase {
    userId!: number;
    order!: number;
    useDefaultAvailability!: boolean;
    calendarAvailability!: CalendarAvailability;
    location!: string | undefined;
    locationType!: LocationType;

    constructor(data?: IEventTypeHostBase) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.calendarAvailability = data.calendarAvailability && !(<any>data.calendarAvailability).toJSON ? new CalendarAvailability(data.calendarAvailability) : <CalendarAvailability>this.calendarAvailability;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.order = _data["order"];
            this.useDefaultAvailability = _data["useDefaultAvailability"];
            this.calendarAvailability = _data["calendarAvailability"] ? CalendarAvailability.fromJS(_data["calendarAvailability"]) : <any>undefined;
            this.location = _data["location"];
            this.locationType = _data["locationType"];
        }
    }

    static fromJS(data: any): EventTypeHostBase {
        data = typeof data === 'object' ? data : {};
        let result = new EventTypeHostBase();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["order"] = this.order;
        data["useDefaultAvailability"] = this.useDefaultAvailability;
        data["calendarAvailability"] = this.calendarAvailability ? this.calendarAvailability.toJSON() : <any>undefined;
        data["location"] = this.location;
        data["locationType"] = this.locationType;
        return data;
    }
}

export interface IEventTypeHostBase {
    userId: number;
    order: number;
    useDefaultAvailability: boolean;
    calendarAvailability: ICalendarAvailability;
    location: string | undefined;
    locationType: LocationType;
}

export class EventTypeHostDto implements IEventTypeHostDto {
    userId!: number;
    order!: number;
    useDefaultAvailability!: boolean;
    calendarAvailability!: CalendarAvailability;
    location!: string | undefined;
    locationType!: LocationType;
    user!: HostUserDto;

    constructor(data?: IEventTypeHostDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.calendarAvailability = data.calendarAvailability && !(<any>data.calendarAvailability).toJSON ? new CalendarAvailability(data.calendarAvailability) : <CalendarAvailability>this.calendarAvailability;
            this.user = data.user && !(<any>data.user).toJSON ? new HostUserDto(data.user) : <HostUserDto>this.user;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.order = _data["order"];
            this.useDefaultAvailability = _data["useDefaultAvailability"];
            this.calendarAvailability = _data["calendarAvailability"] ? CalendarAvailability.fromJS(_data["calendarAvailability"]) : <any>undefined;
            this.location = _data["location"];
            this.locationType = _data["locationType"];
            this.user = _data["user"] ? HostUserDto.fromJS(_data["user"]) : <any>undefined;
        }
    }

    static fromJS(data: any): EventTypeHostDto {
        data = typeof data === 'object' ? data : {};
        let result = new EventTypeHostDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["order"] = this.order;
        data["useDefaultAvailability"] = this.useDefaultAvailability;
        data["calendarAvailability"] = this.calendarAvailability ? this.calendarAvailability.toJSON() : <any>undefined;
        data["location"] = this.location;
        data["locationType"] = this.locationType;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        return data;
    }
}

export interface IEventTypeHostDto {
    userId: number;
    order: number;
    useDefaultAvailability: boolean;
    calendarAvailability: ICalendarAvailability;
    location: string | undefined;
    locationType: LocationType;
    user: IHostUserDto;
}

export enum EventTypes {
    _0 = 0,
    _1 = 1,
}

export class GetSlotsForEditorPreviewInput implements IGetSlotsForEditorPreviewInput {
    start!: Date;
    end!: Date;
    duration!: number;
    calendarAvailability!: CalendarAvailability;
    dateRangeType!: string | undefined;
    dateRangeRollingPeriod!: number | undefined;
    dateRangeDateRange!: DateTimeRange;
    availabilityIncrements!: number;
    minimumNoticeMinutes!: number;
    hosts!: EventTypeHostBase[] | undefined;
    maxAttendees!: number;
    eventType!: EventTypes;
    bufferStartMinutes!: number;
    bufferEndMinutes!: number;

    constructor(data?: IGetSlotsForEditorPreviewInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.calendarAvailability = data.calendarAvailability && !(<any>data.calendarAvailability).toJSON ? new CalendarAvailability(data.calendarAvailability) : <CalendarAvailability>this.calendarAvailability;
            this.dateRangeDateRange = data.dateRangeDateRange && !(<any>data.dateRangeDateRange).toJSON ? new DateTimeRange(data.dateRangeDateRange) : <DateTimeRange>this.dateRangeDateRange;
            if (data.hosts) {
                this.hosts = [];
                for (let i = 0; i < data.hosts.length; i++) {
                    let item = data.hosts[i];
                    this.hosts[i] = item && !(<any>item).toJSON ? new EventTypeHostBase(item) : <EventTypeHostBase>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.start = _data["start"] ? new Date(_data["start"].toString()) : <any>undefined;
            this.end = _data["end"] ? new Date(_data["end"].toString()) : <any>undefined;
            this.duration = _data["duration"];
            this.calendarAvailability = _data["calendarAvailability"] ? CalendarAvailability.fromJS(_data["calendarAvailability"]) : <any>undefined;
            this.dateRangeType = _data["dateRangeType"];
            this.dateRangeRollingPeriod = _data["dateRangeRollingPeriod"];
            this.dateRangeDateRange = _data["dateRangeDateRange"] ? DateTimeRange.fromJS(_data["dateRangeDateRange"]) : <any>undefined;
            this.availabilityIncrements = _data["availabilityIncrements"];
            this.minimumNoticeMinutes = _data["minimumNoticeMinutes"];
            if (Array.isArray(_data["hosts"])) {
                this.hosts = [] as any;
                for (let item of _data["hosts"])
                    this.hosts!.push(EventTypeHostBase.fromJS(item));
            }
            this.maxAttendees = _data["maxAttendees"];
            this.eventType = _data["eventType"];
            this.bufferStartMinutes = _data["bufferStartMinutes"];
            this.bufferEndMinutes = _data["bufferEndMinutes"];
        }
    }

    static fromJS(data: any): GetSlotsForEditorPreviewInput {
        data = typeof data === 'object' ? data : {};
        let result = new GetSlotsForEditorPreviewInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["start"] = this.start ? this.start.toISOString() : <any>undefined;
        data["end"] = this.end ? this.end.toISOString() : <any>undefined;
        data["duration"] = this.duration;
        data["calendarAvailability"] = this.calendarAvailability ? this.calendarAvailability.toJSON() : <any>undefined;
        data["dateRangeType"] = this.dateRangeType;
        data["dateRangeRollingPeriod"] = this.dateRangeRollingPeriod;
        data["dateRangeDateRange"] = this.dateRangeDateRange ? this.dateRangeDateRange.toJSON() : <any>undefined;
        data["availabilityIncrements"] = this.availabilityIncrements;
        data["minimumNoticeMinutes"] = this.minimumNoticeMinutes;
        if (Array.isArray(this.hosts)) {
            data["hosts"] = [];
            for (let item of this.hosts)
                data["hosts"].push(item.toJSON());
        }
        data["maxAttendees"] = this.maxAttendees;
        data["eventType"] = this.eventType;
        data["bufferStartMinutes"] = this.bufferStartMinutes;
        data["bufferEndMinutes"] = this.bufferEndMinutes;
        return data;
    }
}

export interface IGetSlotsForEditorPreviewInput {
    start: Date;
    end: Date;
    duration: number;
    calendarAvailability: ICalendarAvailability;
    dateRangeType: string | undefined;
    dateRangeRollingPeriod: number | undefined;
    dateRangeDateRange: IDateTimeRange;
    availabilityIncrements: number;
    minimumNoticeMinutes: number;
    hosts: IEventTypeHostBase[] | undefined;
    maxAttendees: number;
    eventType: EventTypes;
    bufferStartMinutes: number;
    bufferEndMinutes: number;
}

export class GetSlotsOutput implements IGetSlotsOutput {
    slots!: CalendarSlot[] | undefined;

    constructor(data?: IGetSlotsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.slots) {
                this.slots = [];
                for (let i = 0; i < data.slots.length; i++) {
                    let item = data.slots[i];
                    this.slots[i] = item && !(<any>item).toJSON ? new CalendarSlot(item) : <CalendarSlot>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["slots"])) {
                this.slots = [] as any;
                for (let item of _data["slots"])
                    this.slots!.push(CalendarSlot.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetSlotsOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetSlotsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.slots)) {
            data["slots"] = [];
            for (let item of this.slots)
                data["slots"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetSlotsOutput {
    slots: ICalendarSlot[] | undefined;
}

export class GuestQuestion implements IGuestQuestion {
    enabled!: boolean;
    required!: boolean;
    question!: string;
    answerType!: string;
    choices!: string[] | undefined;
    freeChoice!: boolean | undefined;

    constructor(data?: IGuestQuestion) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.enabled = _data["enabled"];
            this.required = _data["required"];
            this.question = _data["question"];
            this.answerType = _data["answerType"];
            if (Array.isArray(_data["choices"])) {
                this.choices = [] as any;
                for (let item of _data["choices"])
                    this.choices!.push(item);
            }
            this.freeChoice = _data["freeChoice"];
        }
    }

    static fromJS(data: any): GuestQuestion {
        data = typeof data === 'object' ? data : {};
        let result = new GuestQuestion();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["enabled"] = this.enabled;
        data["required"] = this.required;
        data["question"] = this.question;
        data["answerType"] = this.answerType;
        if (Array.isArray(this.choices)) {
            data["choices"] = [];
            for (let item of this.choices)
                data["choices"].push(item);
        }
        data["freeChoice"] = this.freeChoice;
        return data;
    }
}

export interface IGuestQuestion {
    enabled: boolean;
    required: boolean;
    question: string;
    answerType: string;
    choices: string[] | undefined;
    freeChoice: boolean | undefined;
}

export class GuestQuestionAnswers implements IGuestQuestionAnswers {
    answerType!: string | undefined;
    question!: string | undefined;
    answers!: string[] | undefined;

    constructor(data?: IGuestQuestionAnswers) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.answerType = _data["answerType"];
            this.question = _data["question"];
            if (Array.isArray(_data["answers"])) {
                this.answers = [] as any;
                for (let item of _data["answers"])
                    this.answers!.push(item);
            }
        }
    }

    static fromJS(data: any): GuestQuestionAnswers {
        data = typeof data === 'object' ? data : {};
        let result = new GuestQuestionAnswers();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["answerType"] = this.answerType;
        data["question"] = this.question;
        if (Array.isArray(this.answers)) {
            data["answers"] = [];
            for (let item of this.answers)
                data["answers"].push(item);
        }
        return data;
    }
}

export interface IGuestQuestionAnswers {
    answerType: string | undefined;
    question: string | undefined;
    answers: string[] | undefined;
}

export class HostUserDto implements IHostUserDto {
    id!: number;
    userName!: string;
    name!: string;
    surname!: string;
    companyName!: string | undefined;
    emailAddress!: string;
    fullName!: string | undefined;
    timezone!: string | undefined;

    constructor(data?: IHostUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userName = _data["userName"];
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.companyName = _data["companyName"];
            this.emailAddress = _data["emailAddress"];
            this.fullName = _data["fullName"];
            this.timezone = _data["timezone"];
        }
    }

    static fromJS(data: any): HostUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new HostUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userName"] = this.userName;
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["companyName"] = this.companyName;
        data["emailAddress"] = this.emailAddress;
        data["fullName"] = this.fullName;
        data["timezone"] = this.timezone;
        return data;
    }
}

export interface IHostUserDto {
    id: number;
    userName: string;
    name: string;
    surname: string;
    companyName: string | undefined;
    emailAddress: string;
    fullName: string | undefined;
    timezone: string | undefined;
}

export enum LocationSettingEnum {
    _0 = 0,
    _1 = 1,
    _2 = 2,
}

export enum LocationType {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
}

export class OwnerCalendarDto implements IOwnerCalendarDto {
    id!: string;
    name!: string | undefined;
    url!: string | undefined;
    calendarOptions!: CalendarOptions;
    isActive!: boolean;
    isDeleted!: boolean;
    ownerId!: number;
    ownerFullName!: string | undefined;
    eventTypeHosts!: EventTypeHostDto[] | undefined;
    paymentAccount!: PaymentAccountDto;
    paymentTerms!: string | undefined;
    durationPackages!: DurationPackageDto[] | undefined;
    paymentCurrency!: string | undefined;
    organizerId!: number | undefined;
    startBufferMinutes!: number;
    endBufferMinutes!: number;
    eventType!: EventTypes;
    groupLeaderUserId!: number | undefined;

    constructor(data?: IOwnerCalendarDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.calendarOptions = data.calendarOptions && !(<any>data.calendarOptions).toJSON ? new CalendarOptions(data.calendarOptions) : <CalendarOptions>this.calendarOptions;
            if (data.eventTypeHosts) {
                this.eventTypeHosts = [];
                for (let i = 0; i < data.eventTypeHosts.length; i++) {
                    let item = data.eventTypeHosts[i];
                    this.eventTypeHosts[i] = item && !(<any>item).toJSON ? new EventTypeHostDto(item) : <EventTypeHostDto>item;
                }
            }
            this.paymentAccount = data.paymentAccount && !(<any>data.paymentAccount).toJSON ? new PaymentAccountDto(data.paymentAccount) : <PaymentAccountDto>this.paymentAccount;
            if (data.durationPackages) {
                this.durationPackages = [];
                for (let i = 0; i < data.durationPackages.length; i++) {
                    let item = data.durationPackages[i];
                    this.durationPackages[i] = item && !(<any>item).toJSON ? new DurationPackageDto(item) : <DurationPackageDto>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.url = _data["url"];
            this.calendarOptions = _data["calendarOptions"] ? CalendarOptions.fromJS(_data["calendarOptions"]) : <any>undefined;
            this.isActive = _data["isActive"];
            this.isDeleted = _data["isDeleted"];
            this.ownerId = _data["ownerId"];
            this.ownerFullName = _data["ownerFullName"];
            if (Array.isArray(_data["eventTypeHosts"])) {
                this.eventTypeHosts = [] as any;
                for (let item of _data["eventTypeHosts"])
                    this.eventTypeHosts!.push(EventTypeHostDto.fromJS(item));
            }
            this.paymentAccount = _data["paymentAccount"] ? PaymentAccountDto.fromJS(_data["paymentAccount"]) : <any>undefined;
            this.paymentTerms = _data["paymentTerms"];
            if (Array.isArray(_data["durationPackages"])) {
                this.durationPackages = [] as any;
                for (let item of _data["durationPackages"])
                    this.durationPackages!.push(DurationPackageDto.fromJS(item));
            }
            this.paymentCurrency = _data["paymentCurrency"];
            this.organizerId = _data["organizerId"];
            this.startBufferMinutes = _data["startBufferMinutes"];
            this.endBufferMinutes = _data["endBufferMinutes"];
            this.eventType = _data["eventType"];
            this.groupLeaderUserId = _data["groupLeaderUserId"];
        }
    }

    static fromJS(data: any): OwnerCalendarDto {
        data = typeof data === 'object' ? data : {};
        let result = new OwnerCalendarDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["url"] = this.url;
        data["calendarOptions"] = this.calendarOptions ? this.calendarOptions.toJSON() : <any>undefined;
        data["isActive"] = this.isActive;
        data["isDeleted"] = this.isDeleted;
        data["ownerId"] = this.ownerId;
        data["ownerFullName"] = this.ownerFullName;
        if (Array.isArray(this.eventTypeHosts)) {
            data["eventTypeHosts"] = [];
            for (let item of this.eventTypeHosts)
                data["eventTypeHosts"].push(item.toJSON());
        }
        data["paymentAccount"] = this.paymentAccount ? this.paymentAccount.toJSON() : <any>undefined;
        data["paymentTerms"] = this.paymentTerms;
        if (Array.isArray(this.durationPackages)) {
            data["durationPackages"] = [];
            for (let item of this.durationPackages)
                data["durationPackages"].push(item.toJSON());
        }
        data["paymentCurrency"] = this.paymentCurrency;
        data["organizerId"] = this.organizerId;
        data["startBufferMinutes"] = this.startBufferMinutes;
        data["endBufferMinutes"] = this.endBufferMinutes;
        data["eventType"] = this.eventType;
        data["groupLeaderUserId"] = this.groupLeaderUserId;
        return data;
    }
}

export interface IOwnerCalendarDto {
    id: string;
    name: string | undefined;
    url: string | undefined;
    calendarOptions: ICalendarOptions;
    isActive: boolean;
    isDeleted: boolean;
    ownerId: number;
    ownerFullName: string | undefined;
    eventTypeHosts: IEventTypeHostDto[] | undefined;
    paymentAccount: IPaymentAccountDto;
    paymentTerms: string | undefined;
    durationPackages: IDurationPackageDto[] | undefined;
    paymentCurrency: string | undefined;
    organizerId: number | undefined;
    startBufferMinutes: number;
    endBufferMinutes: number;
    eventType: EventTypes;
    groupLeaderUserId: number | undefined;
}

export class PaymentAccountDto implements IPaymentAccountDto {
    id!: string;
    externalId!: string | undefined;
    isActive!: boolean;
    name!: string | undefined;

    constructor(data?: IPaymentAccountDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.externalId = _data["externalId"];
            this.isActive = _data["isActive"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): PaymentAccountDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentAccountDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["externalId"] = this.externalId;
        data["isActive"] = this.isActive;
        data["name"] = this.name;
        return data;
    }
}

export interface IPaymentAccountDto {
    id: string;
    externalId: string | undefined;
    isActive: boolean;
    name: string | undefined;
}

export class PossibleEventTypeHostDto implements IPossibleEventTypeHostDto {
    userId!: number;
    userTimezone!: string | undefined;
    userEmailAddress!: string | undefined;
    userUserName!: string | undefined;
    userName!: string | undefined;
    userSurname!: string | undefined;
    userCalendarAvailability!: CalendarAvailability;
    canGoogleMeetIntegrate!: boolean;
    canZoomIntegrate!: boolean;
    zoomAccounts!: ZoomAccountDto[] | undefined;
    canMicrosoftTeamMeetingIntegrate!: boolean;

    constructor(data?: IPossibleEventTypeHostDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.userCalendarAvailability = data.userCalendarAvailability && !(<any>data.userCalendarAvailability).toJSON ? new CalendarAvailability(data.userCalendarAvailability) : <CalendarAvailability>this.userCalendarAvailability;
            if (data.zoomAccounts) {
                this.zoomAccounts = [];
                for (let i = 0; i < data.zoomAccounts.length; i++) {
                    let item = data.zoomAccounts[i];
                    this.zoomAccounts[i] = item && !(<any>item).toJSON ? new ZoomAccountDto(item) : <ZoomAccountDto>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.userTimezone = _data["userTimezone"];
            this.userEmailAddress = _data["userEmailAddress"];
            this.userUserName = _data["userUserName"];
            this.userName = _data["userName"];
            this.userSurname = _data["userSurname"];
            this.userCalendarAvailability = _data["userCalendarAvailability"] ? CalendarAvailability.fromJS(_data["userCalendarAvailability"]) : <any>undefined;
            this.canGoogleMeetIntegrate = _data["canGoogleMeetIntegrate"];
            this.canZoomIntegrate = _data["canZoomIntegrate"];
            if (Array.isArray(_data["zoomAccounts"])) {
                this.zoomAccounts = [] as any;
                for (let item of _data["zoomAccounts"])
                    this.zoomAccounts!.push(ZoomAccountDto.fromJS(item));
            }
            this.canMicrosoftTeamMeetingIntegrate = _data["canMicrosoftTeamMeetingIntegrate"];
        }
    }

    static fromJS(data: any): PossibleEventTypeHostDto {
        data = typeof data === 'object' ? data : {};
        let result = new PossibleEventTypeHostDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["userTimezone"] = this.userTimezone;
        data["userEmailAddress"] = this.userEmailAddress;
        data["userUserName"] = this.userUserName;
        data["userName"] = this.userName;
        data["userSurname"] = this.userSurname;
        data["userCalendarAvailability"] = this.userCalendarAvailability ? this.userCalendarAvailability.toJSON() : <any>undefined;
        data["canGoogleMeetIntegrate"] = this.canGoogleMeetIntegrate;
        data["canZoomIntegrate"] = this.canZoomIntegrate;
        if (Array.isArray(this.zoomAccounts)) {
            data["zoomAccounts"] = [];
            for (let item of this.zoomAccounts)
                data["zoomAccounts"].push(item.toJSON());
        }
        data["canMicrosoftTeamMeetingIntegrate"] = this.canMicrosoftTeamMeetingIntegrate;
        return data;
    }
}

export interface IPossibleEventTypeHostDto {
    userId: number;
    userTimezone: string | undefined;
    userEmailAddress: string | undefined;
    userUserName: string | undefined;
    userName: string | undefined;
    userSurname: string | undefined;
    userCalendarAvailability: ICalendarAvailability;
    canGoogleMeetIntegrate: boolean;
    canZoomIntegrate: boolean;
    zoomAccounts: IZoomAccountDto[] | undefined;
    canMicrosoftTeamMeetingIntegrate: boolean;
}

export class SaveCalendarInput implements ISaveCalendarInput {
    id!: string | undefined;
    name!: string;
    url!: string;
    isActive!: boolean;
    eventTypeHosts!: EventTypeHostBase[] | undefined;
    durationPackages!: DurationPackageInput[];
    organizerId!: number;
    groupLeaderUserId!: number;
    paymentCurrency!: string | undefined;
    paymentAccountId!: string | undefined;
    paymentTerms!: string | undefined;
    calendarOptions!: CalendarOptionsInput;
    eventType!: EventTypes;
    startBufferMinutes!: number;
    endBufferMinutes!: number;

    constructor(data?: ISaveCalendarInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.eventTypeHosts) {
                this.eventTypeHosts = [];
                for (let i = 0; i < data.eventTypeHosts.length; i++) {
                    let item = data.eventTypeHosts[i];
                    this.eventTypeHosts[i] = item && !(<any>item).toJSON ? new EventTypeHostBase(item) : <EventTypeHostBase>item;
                }
            }
            if (data.durationPackages) {
                this.durationPackages = [];
                for (let i = 0; i < data.durationPackages.length; i++) {
                    let item = data.durationPackages[i];
                    this.durationPackages[i] = item && !(<any>item).toJSON ? new DurationPackageInput(item) : <DurationPackageInput>item;
                }
            }
            this.calendarOptions = data.calendarOptions && !(<any>data.calendarOptions).toJSON ? new CalendarOptionsInput(data.calendarOptions) : <CalendarOptionsInput>this.calendarOptions;
        }
        if (!data) {
            this.durationPackages = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.url = _data["url"];
            this.isActive = _data["isActive"];
            if (Array.isArray(_data["eventTypeHosts"])) {
                this.eventTypeHosts = [] as any;
                for (let item of _data["eventTypeHosts"])
                    this.eventTypeHosts!.push(EventTypeHostBase.fromJS(item));
            }
            if (Array.isArray(_data["durationPackages"])) {
                this.durationPackages = [] as any;
                for (let item of _data["durationPackages"])
                    this.durationPackages!.push(DurationPackageInput.fromJS(item));
            }
            this.organizerId = _data["organizerId"];
            this.groupLeaderUserId = _data["groupLeaderUserId"];
            this.paymentCurrency = _data["paymentCurrency"];
            this.paymentAccountId = _data["paymentAccountId"];
            this.paymentTerms = _data["paymentTerms"];
            this.calendarOptions = _data["calendarOptions"] ? CalendarOptionsInput.fromJS(_data["calendarOptions"]) : <any>undefined;
            this.eventType = _data["eventType"];
            this.startBufferMinutes = _data["startBufferMinutes"];
            this.endBufferMinutes = _data["endBufferMinutes"];
        }
    }

    static fromJS(data: any): SaveCalendarInput {
        data = typeof data === 'object' ? data : {};
        let result = new SaveCalendarInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["url"] = this.url;
        data["isActive"] = this.isActive;
        if (Array.isArray(this.eventTypeHosts)) {
            data["eventTypeHosts"] = [];
            for (let item of this.eventTypeHosts)
                data["eventTypeHosts"].push(item.toJSON());
        }
        if (Array.isArray(this.durationPackages)) {
            data["durationPackages"] = [];
            for (let item of this.durationPackages)
                data["durationPackages"].push(item.toJSON());
        }
        data["organizerId"] = this.organizerId;
        data["groupLeaderUserId"] = this.groupLeaderUserId;
        data["paymentCurrency"] = this.paymentCurrency;
        data["paymentAccountId"] = this.paymentAccountId;
        data["paymentTerms"] = this.paymentTerms;
        data["calendarOptions"] = this.calendarOptions ? this.calendarOptions.toJSON() : <any>undefined;
        data["eventType"] = this.eventType;
        data["startBufferMinutes"] = this.startBufferMinutes;
        data["endBufferMinutes"] = this.endBufferMinutes;
        return data;
    }
}

export interface ISaveCalendarInput {
    id: string | undefined;
    name: string;
    url: string;
    isActive: boolean;
    eventTypeHosts: IEventTypeHostBase[] | undefined;
    durationPackages: IDurationPackageInput[];
    organizerId: number;
    groupLeaderUserId: number;
    paymentCurrency: string | undefined;
    paymentAccountId: string | undefined;
    paymentTerms: string | undefined;
    calendarOptions: ICalendarOptionsInput;
    eventType: EventTypes;
    startBufferMinutes: number;
    endBufferMinutes: number;
}

export class Time implements ITime {
    hours!: number;
    minutes!: number;

    constructor(data?: ITime) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.hours = _data["hours"];
            this.minutes = _data["minutes"];
        }
    }

    static fromJS(data: any): Time {
        data = typeof data === 'object' ? data : {};
        let result = new Time();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hours"] = this.hours;
        data["minutes"] = this.minutes;
        return data;
    }
}

export interface ITime {
    hours: number;
    minutes: number;
}

export class TimeRange implements ITimeRange {
    start!: Time;
    end!: Time;

    constructor(data?: ITimeRange) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.start = data.start && !(<any>data.start).toJSON ? new Time(data.start) : <Time>this.start;
            this.end = data.end && !(<any>data.end).toJSON ? new Time(data.end) : <Time>this.end;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.start = _data["start"] ? Time.fromJS(_data["start"]) : <any>undefined;
            this.end = _data["end"] ? Time.fromJS(_data["end"]) : <any>undefined;
        }
    }

    static fromJS(data: any): TimeRange {
        data = typeof data === 'object' ? data : {};
        let result = new TimeRange();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["start"] = this.start ? this.start.toJSON() : <any>undefined;
        data["end"] = this.end ? this.end.toJSON() : <any>undefined;
        return data;
    }
}

export interface ITimeRange {
    start: ITime;
    end: ITime;
}

export class ZoomAccountDto implements IZoomAccountDto {
    id!: string;
    email!: string | undefined;

    constructor(data?: IZoomAccountDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): ZoomAccountDto {
        data = typeof data === 'object' ? data : {};
        let result = new ZoomAccountDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["email"] = this.email;
        return data;
    }
}

export interface IZoomAccountDto {
    id: string;
    email: string | undefined;
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new ApiException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((event.target as any).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}